import React, { useEffect, useState } from "react";
import momentLocalizer from "react-widgets-moment"
import { FormattedMessage } from "react-intl";
import config from "../../../helpers/config.helper";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const appConfig = config();
const dateFormat = appConfig.REACT_APP_DATE_FORMAT;

momentLocalizer();

type PropsType = {
    input: any;
    labelText: string;
    minDate: string;
    disabled: boolean;
    EndDate?:string;
    meta: {
        dirty: boolean;
        touched: boolean;
        error: string;
        warning: string;
    };
};

const DateTimeWidget = (props: PropsType) => {

    const { input, minDate, disabled, meta } = props;
    const { dirty, error, touched } = meta;
    const [EndDate, setEndDate] = useState<any>(props.EndDate) 
    
    // const onChange = (date: any) => {
    //     const dateStr = moment(date, dateFormat, true).isValid() ? moment(date).format(dateFormat) : undefined;
    //     input.onChange(dateStr);
    // };
    const onChange = (date: any) => {
        input.onChange(date ? moment(date).format(dateFormat) : null);
    };

  
    useEffect(() => {    
        EndDate && input.onChange(EndDate);
        setEndDate('')
        document.querySelectorAll(".rw-btn.rw-btn-select").forEach(el => {
            el?.removeAttribute("title");
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(() => { 
        if(disabled && error){
            input.onChange(moment((new Date())).format(dateFormat));
        }
    },[disabled, error, input])    
    // const { language }: any = useSelector((state: any) => {
    //     return state.dashboardControl;
    // });

    return (
        <div className="form-group">
            {/* <DateTimePicker
                onChange={onChange}
                format={dateFormat}
                time={false}
                min={minDate ? new Date(minDate) : undefined}
                max={new Date()}
                value={input.value ? new Date(input.value) : undefined}
                disabled={disabled}
                inputProps={{
                    component: (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLInputElement> & React.InputHTMLAttributes<HTMLInputElement>) => <input {...props} readOnly />
                }}
            // for DD-MM-YYYY format:  moment(props.input.value, "DD-MM-YYYY").toDate()}

            /> */}
            <DatePicker
                dateFormat="yyyy-MM-dd"
                //peekNextMonth
                disabled={disabled}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={minDate ? new Date(minDate) : undefined}
                maxDate={new Date()}
                //placeholderText={props.EndDate && props.EndDate}
                // selected={moment(input.value, dateFormat, true).isValid() ? new Date(input.value) : undefined}
                selected={
                    input.value && moment(input.value, dateFormat, true).isValid()
                        ? moment(input.value, dateFormat).toDate()
                        : null
                    }
                onChange={(date: any) => onChange(date)} />
            {(dirty || touched) &&
                ((error && <span className="text-danger errorMessage"><FormattedMessage id={error} /></span>))}
        </div>
    );
};

export default DateTimeWidget;
